import BoxImage from "@components/BoxImage";
import ButtonContainer from "@components/ButtonContainer";
import { ReactElement } from "react";
import { Col } from "reactstrap";
import { TProjectDto } from "types/Project/projectDto";
import styles from "./DetailForm.module.scss";

interface IDetailForm {
  data: TProjectDto;
}

const DetailArtist = ({ data }: IDetailForm): ReactElement => (
  <form className={`${styles.detailForm} form`}>
    <div className={styles.media}>
      <BoxImage urlImage={data?.bannerUrl} />
    </div>

    <Col md={6}>
      <div className="form__form-group">
        <span className="form__form-group-label">Name</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.name} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Artist</span>
        <div className="form__form-group-field">
          <input value={data?.artist} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Categories</span>
        <div className="form__form-group-field">
          <input value={data?.category} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Type</span>
        <div className="form__form-group-field">
          <input value={data?.projectType} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Listing Type</span>
        <div className="form__form-group-field">
          <input value={data?.listingType} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Network</span>
        <div className="form__form-group-field">
          <input value={data?.network} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Max Supply</span>
        <div className="form__form-group-field">
          <input value={data?.maxSupply} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Status</span>
        <div className="form__form-group-field">
          <input value={data?.status} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Featured</span>
        <div className="form__form-group-field">
          <input value={data?.featured} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Banned</span>
        <div className="form__form-group-field">
          <input value={data?.banned} disabled />
        </div>
      </div>
    </Col>

    <Col md={6}>
      <div className="form__form-group">
        <span className="form__form-group-label">Description</span>
        <div className="form__form-group-field">
          <textarea value={data?.description} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Certificate Url</span>
        <div className="form__form-group-field">
          <input value={data?.provenanceCertificateUrl} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Mint Price</span>
        <div className="form__form-group-field">
          <input value={data?.mintPrice} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Mint Address</span>
        <div className="form__form-group-field">
          <input value={data?.mintAddress} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Token Address</span>
        <div className="form__form-group-field">
          <input value={data?.tokenAddress} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Contract Type</span>
        <div className="form__form-group-field">
          <input value={data?.contractType} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Physical Piece</span>
        <div className="form__form-group-field">
          <input value={data?.isPhysicalPiece} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Created At</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.createdAt} disabled />
        </div>
      </div>
    </Col>

    <ButtonContainer />
  </form>
);

export default DetailArtist;
